/**
 * Reference-URL validation, isolated in a dependency-free module so it
 * can be imported by lightweight stores (e.g. the provide-phase draft
 * store) without dragging in the network-bound `statementReferences`
 * service and its transitive `fetchClient` chain.
 *
 * `statementReferences.ts` re-exports both symbols, so existing callers
 * that import them from there keep working.
 */

/** The accepted shape for an author-supplied reference URL. */
export const URL_PATTERN = /^https?:\/\/\S+$/i;

/** True when `value` (after trimming) is an `http(s)` URL. */
export function isValidReferenceUrl(value: string): boolean {
  return URL_PATTERN.test(value.trim());
}
